import React, {useEffect, useState} from 'react';
import {FormControl} from "@mui/material";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
// import RaikoImageCropper from "../raikoImageCropper/RaikoImageCropper";
// import {dataURLtoFile} from "../../util/converBase64ToImage";
import {css} from "@emotion/css";
import {
    RaikoBaseCardContainer,
    RaikoDivider,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput, RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
    RaikoGridThreeColumn,
    RaikoGridFourColumn,
    RaikoToggleOutlined,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {AdminRoles} from "../../context/reducer";


const UserProfileDetailPage = (
    {
        profileDetail,
        setProfileDetail,
        // avatarFile,
        // setAvatarFile,
        service,
        adminId = -1,
        // avatarLoadingState = false
    }) => {


    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    useEffect(() => {
        if (profileDetail && profileDetail.firstName) {
            setProfileDataToFields();
        }
    }, [profileDetail])


    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [username, setUsername] = useState("");
    const [enabled, setEnabled] = useState(true);
    const [rolesList, setRolesList] = useState([]);
    const [role, setRole] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    // const [imageFile, setImageFile] = useState(null);
    // const [imageId, setImageId] = useState(-1);
    // const [image, setImage] = useState(null)

    // const [avatarLoading, setAvatarLoading] = useState(avatarLoadingState)

    // const onImageChange = (event) => {
    //     if (event.target.files && event.target.files[0]) {
    //         setImageFile(event.target.files[0]);
    //         setImageId(-1)
    //         setImage(URL.createObjectURL(event.target.files[0]));
    //     }
    // }

    // function eraseImage() {
    //     setImageFile(null)
    //     setImage(null)
    //     setImageId(-1)
    // }
    function setProfileDataToFields() {
        setFirstName(profileDetail.firstName)
        setLastName(profileDetail.lastName)
        setNationalCode(profileDetail.nationalCode)
        setUsername(profileDetail.username)
        setPhoneNumber(profileDetail.phoneNumber)
        setRolesList(profileDetail.roles)
        setRole(profileDetail.roles[0])
    }


    function checkFields() {
        let message = ""
        let state = false

        if (firstName.length === 0)
            message = "لطفا نام ادمین را وارد نمایید!"
        else if (lastName.length === 0)
            message = "لطفا نام خانوادگی ادمین را وارد نمایید!"
        else if (username.trim().length <= 7)
            message = "نام کاربری باید حداقل 8 حرف داشته باشد!"
        else if (nationalCode.length < 8)
            message = "خطا، لطفا کد ملی مدیر را به درستی وارد نمایید!"
        else if (phoneNumber.length !== 11)
            message = "لطفا شماره همراه ادمین را به درستی وارد نمایید!"
        else
            state = true

        if (message.length > 0)
            showWarningMessage(message)

        return state
    }

    function handleUpdateDetail() {
        if (checkFields()) {
            if (adminId >= 0) {
                updateManagerInfo()
            } else {
                updateAdminInfo()
            }
        }
    }

    function updateManagerInfo() {
        loading.show()
        service.updateProfileDetailById(
            adminId,
            {
                "enabled": enabled,
                "firstName": firstName,
                "lastName": lastName,
                "phoneNumber": phoneNumber,
                "nationalCode": nationalCode,
                "username": username,
                "roles": rolesList
            }).then(response => {
            setProfileDetail(response)
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
            loading.hide()
        })
    }

    function updateAdminInfo() {
        loading.show()
        service.updateProfileInfo({
            enabled: true,
            "firstName": firstName,
            "lastName": lastName,
            "username": username,
            "nationalCode": nationalCode,
            "phoneNumber": phoneNumber
        }).then(response => {
            setProfileDetail(response)
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
            loading.hide()
        })
    }


    // const updateAvatar = (imgSrc, fileName) => {
    //     loading.show()
    //     const imageFile = dataURLtoFile(imgSrc, fileName)
    //
    //     service.updateAdminAvatar(imageFile, adminId)
    //         .then(response => {
    //             setAvatarFile(response.downloadUrl)
    //             showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
    //             loading.hide()
    //         }).catch(reason => {
    //         showErrorMessage(detectServerErrorMessage(reason))
    //         loading.hide()
    //     })
    // }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 1rem`}>
            <RaikoSectionContainer
                title={"حساب کاربری"}
                hasActionButton
                actionButtonOnclick={handleUpdateDetail}
            >
                <RaikoGridOneColumn>
                    {/*<RaikoImageCropper*/}
                    {/*    avatarFile={avatarFile}*/}
                    {/*    updateAvatar={updateAvatar}*/}
                    {/*    loading={avatarLoading}*/}
                    {/*/>*/}
                    <RaikoDivider/>
                    <RaikoGridOneColumn>
                        <RaikoGridThreeColumn>
                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام"}
                                    value={firstName}
                                    setValue={setFirstName}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام خانوادگی"}
                                    value={lastName}
                                    setValue={setLastName}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام کاربری"}
                                    value={username}
                                    setValue={setUsername}

                                />
                            </FormControl>
                            <FormControl>
                                <RaikoNumberInputOutlined
                                    maxLength={"10"}
                                    value={nationalCode}
                                    setValue={setNationalCode}
                                    labelText={"کد ملی"}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <RaikoMobileInputOutlined
                                    placeHolder={"091..."}
                                    labelText={"شماره همراه"}
                                    value={phoneNumber}
                                    setValue={setPhoneNumber}
                                />
                            </FormControl>
                            <RaikoCustomSelect
                                labelText={"سطح دسترسی"}
                                value={role}
                                setValue={setRole}
                                onChange={e => {
                                    setRole(e.target.value)
                                    setRolesList([e.target.value])
                                }}
                                items={[
                                    raikoCustomSelectItemGenerator(AdminRoles.SUPER_ADMIN.role, AdminRoles.SUPER_ADMIN.name),
                                    raikoCustomSelectItemGenerator(AdminRoles.FUND_MANAGER.role, AdminRoles.FUND_MANAGER.name),
                                    raikoCustomSelectItemGenerator(AdminRoles.SITE_MANAGER.role, AdminRoles.SITE_MANAGER.name),
                                ]}
                            />

                        </RaikoGridThreeColumn>
                        <RaikoGridOneColumn>
                            <RaikoToggleOutlined
                                labelText={"وضعیت"}
                                setChecked={setEnabled}
                                checked={enabled}
                            />
                        </RaikoGridOneColumn>

                    </RaikoGridOneColumn>
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}

export default UserProfileDetailPage;
